function Summary(params) {
  return(
    <section>
      <p id="summary">
      Motivated and versatile software developer with five years of professional experience in mobile and web development, and a background in QA and hobbyist coding.
      Passionate about building scalable, high-quality applications and staying on top of emerging tech, including AI. 
      <br></br><br></br>
      Proven track record in Agile Scrum environments, working closely with cross-functional teams.
      Continuously improving skills, including regularly participating in the FlutterMTL community and developing personal full-stack projects.
      <br></br><br></br>
      Currently seeking a new opportunity within a growth- and innovation-focused organization.
      </p>
    </section>
  )
}

export default Summary;